// Libs
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from 'notistack';
import useLocalStorage from "use-local-storage";
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

// Components
import Header from "../Header/Header.jsx"
import ImageViewer from './ImageViewer.jsx';
import Loading from "../Loading/Loading.jsx";

// Services
import { GET, ePOST, PUT } from "../../services/Bridge.js"

// Style
import style from './style.module.css';

const FULLNAME_REGEX = /^[A-ZĽŠČŤŽÝÁÍÉÚŇÔ][a-zľščťžýáíéúňôř]+\s[A-ZĽŠČŤŽÝÁÍÉÚŇÔ][a-zľščťžýáíéúňôř]+$/;
const EMAIL_REGEX = /^[^\s@]{1,24}@[^\s@]+\.[^\s@]+$/;
const MOBILENUMBER_REGEX = /^\+?[0-9]{10,15}$/;
const MESSAGE_REGEX = /^.{12,}$/;

const oneWeekAgo = new Date();
oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

const dph = process.env.REACT_APP_DPH;

const Item = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, logMeOut }) => {

    const { id } = useParams();

    const { enqueueSnackbar } = useSnackbar();

    const [openWriteRequest, setOpenWriteRequest] = useState(false);
    const [item, setItem] = useState(null);
    const [saving, setSaving] = useState(false);
    // eslint-disable-next-line
    const [authenticated, setAuthenticated] = useLocalStorage("authenticated", localStorage.authenticated);

    const [fullNameValid, setFullNameValid] = useState(true);
    const [emailValid, setEmailValid] = useState(true);
    const [mobileNumberValid, setMobileNumberValid] = useState(true);
    const [messageValid, setMessageValid] = useState(true);

    const [formData, setFormData] = useState({
      fullName: ``,
      email: ``,
      mobileNumber: ``,
      message: webText.itemSendDemandExampleMessageText,
      item: id
    });

    useEffect(() => {

      const y = async () => {

          try {
              const response = await GET("advertisement", { id: id });
              setItem(response);

              if (!authenticated) await PUT("advertisement-click", null, { id: id });

              window.scrollTo({
                  top: 0,
                  behavior: 'smooth', // Smooth scrolling
              });

          } catch (error) {
              enqueueSnackbar(error, {
                variant: "error",
                autoHideDuration: 5000,
              });
          };
      };

      y();

    // eslint-disable-next-line
    }, []);

    const Feature = ({ feature }) => (
        <div>
          <Tooltip
            title={feature.short}
            placement="top"
            color="main"
            disableInteractive
            arrow
            onClick={(event) => event.stopPropagation()}
          >
            <p>{webLanguage === "sk" ? feature.skTranslation : feature.description}</p>
          </Tooltip>
        </div>
    );

    const handleSendRequest = async () => {

        const v1 = FULLNAME_REGEX.test(formData.fullName);
        const v2 = EMAIL_REGEX.test(formData.email);
        const v3 = MOBILENUMBER_REGEX.test(formData.mobileNumber);
        const v4 = MESSAGE_REGEX.test(formData.message);

        setFullNameValid(v1);
        setEmailValid(v2);
        setMobileNumberValid(v3);
        setMessageValid(v4);

        if (!v1 || !v2 || !v3 || !v4) {
            enqueueSnackbar(webText.itemVerifyUserInputs, {variant: "error", autoHideDuration: 5000});
            return;
        };

        setSaving(true);

        console.log(formData);

        try {
            await ePOST("demand", formData);

            enqueueSnackbar(webText.sended, {
              variant: "success",
              autoHideDuration: 3000,
              onEnter: () => setOpenWriteRequest(false),
              onEntered: () => setSaving(false)
            });

            setFormData({
              fullName: ``,
              email: ``,
              mobileNumber: ``,
              message: webText.itemSendDemandExampleMessageText,
              item: id
            });

        } catch (error) {
            enqueueSnackbar(error, {
              variant: "error",
              autoHideDuration: 5000,
            });
        };
    };

    return (
      <article className={style.page}>
        <Header
          webText={webText}
          toggleTheme={toggleTheme}
          toggleWebLanguage={toggleWebLanguage}
          webLanguage={webLanguage}
          webTheme={webTheme}
          backButton={true}
          logMeOut={logMeOut}
        />
        {!item ? <Loading /> :
          <main className={style.main}>

            <h1 className={style.title}>{item.title}</h1>

            <button className={style.offerBtn} onClick={() => setOpenWriteRequest(true)}>{webText.writeDemandButton}</button>

            <div className={style.images}>
              <ImageViewer item={item}/>
            </div>

            <div className={style.spacer}></div>

            <div className={style.smallInfo}>
              <p>{webText.phoneNumber}:</p>
              <p>{item.mobileNumber}</p>
              <p>{webText.yearOfManufacture}:</p>
              <p>{item.yearOfManufacture}</p>
              <p>{webText.mileage}:</p>
              <p>{item.mileage} Km</p>
              <p>{webText.pricePlaceholder}:</p>
              <p>{item.price} €</p>
              {item.minusDph &&
                <>
                  <p web-theme-color={webTheme} className={style.minusDphPrice}>(Cena bez DPH</p>
                  <p web-theme-color={webTheme} className={style.minusDphPrice}>{Math.round(item.price / dph)} €)</p>
                </>
              }
              {item.minusDph && <p className={style.minusDphText}>- možný odpočet DPH</p>}
              {item.dateAdded >= oneWeekAgo.getTime() ?
                <Tooltip
                  title={webText.chipsNew}
                  placement="top"
                  color="main"
                  disableInteractive
                  arrow
                >
                  <div className={style.newItem}>
                    <svg viewBox="0 0 448 512">
                      <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
                    </svg>
                  </div>
                </Tooltip> : void[0]
              }
              {item.dateAdded >= oneWeekAgo.getTime() ?
                  <p>{webText.itemChipsNew}</p> : null
              }
              {item.stateChips.includes("reserved") ?
                <Tooltip
                  title={webText.chipsReserverd}
                  placement="top"
                  disableInteractive
                  arrow
                >
                  <div className={style.reservedItem}>
                    <svg viewBox="0 0 512 512">
                      <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
                    </svg>
                  </div>
                </Tooltip> : void[0]
              }
              {!item.stateChips.includes("reserved") ? null :
                  <p>{webText.itemChipsReserverd}</p>
              }
              {item.stateChips.includes("prepairing") ?
                <Tooltip
                  title={webText.chipsPrepairing}
                  placement="top"
                  disableInteractive
                  arrow
                >
                  <div className={style.prepairingItem}>
                    <svg viewBox="0 0 448 512">
                      <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/>
                    </svg>
                  </div>
                </Tooltip> : void[0]
              }
              {!item.stateChips.includes("prepairing") ? null :
                  <p>{webText.itemChipsPrepairing}</p>
              }
            </div>

            {item.features.length > 0 &&
              <div className={style.features}>
                {item.features.map((feature, index) => (
                  <Feature key={index} feature={feature}/>
                ))}
              </div>
            }

            {item.description.length > 0 &&
              <div className={style.description}>
                <p>
                  {item.description.split('\n').map((line, index) => (
                      <span key={index}>{line}<br /></span>
                  ))}
                </p>
              </div>
            }

          </main>
        }

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openWriteRequest}
        >
            {!saving ?
              <div className={style.offerMain}>

                  <h1 className={style.title}>{webText.demand}</h1>

                  <button
                    onClick={handleSendRequest}
                    className={style.confirmBtn}
                  >{webText.send}</button>

                  <button
                    onClick={() => setOpenWriteRequest(false)}
                    className={style.cancelBtn}
                  >
                    <svg viewBox="0 0 384 512">
                      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                  </button>

                  <label className={style.labelFullname} htmlFor="fullName">Meno a Priezvisko</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={event => setFormData({...formData, fullName: event.target.value})}
                    placeholder="Adam Novák"
                    className={`${style.inputFullname} ${fullNameValid ? "" : style.wrongInput}`}
                    id="fullName"
                  />

                  <label className={style.labelEmail} htmlFor="email">Email</label>
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={event => setFormData({...formData, email: event.target.value})}
                    placeholder="adam.novak@gmail.com"
                    className={`${style.inputEmail} ${emailValid ? "" : style.wrongInput}`}
                    id="email"
                  />

                  <label className={style.labelMobile} htmlFor="mobileNumber">Mobilné číslo</label>
                  <input
                    type="text"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={event => setFormData({...formData, mobileNumber: event.target.value})}
                    placeholder="+4210987654321"
                    className={`${style.inputMobile} ${mobileNumberValid ? "" : style.wrongInput}`}
                    id="mobileNumber"
                  />

                  <label className={style.labelMessage} htmlFor="message">Správa</label>
                  <textarea
                    name="message"
                    placeholder="Dobrý deň, mám záujem o toto vozidlo..."
                    value={formData.message}
                    onChange={event => setFormData({...formData, message: event.target.value})}
                    className={`${style.inputMessage} ${messageValid ? "" : style.wrongInput}`}
                    id="message"
                  />
              </div>
              :
              <div className={style.offerSending}>
                <p>{webText.sending}</p>
                <CircularProgress color="inherit" />
              </div>
            }
        </Backdrop>
      </article>
    );
};

export default Item;